import { type CbhUserContext, getAnonymousLdUser } from "./cbhUserContext";

/**
 * Re-identifies the anonymous LaunchDarkly context with an unverified submitted
 * email. This attribute must only target progressive-disclosure UX, never
 * security-sensitive behavior. Keeping the context anonymous and omitting its
 * key preserves the SDK's persisted anonymous device key and stable rollout
 * bucketing. Marking email private allows evaluation while redacting it from
 * LaunchDarkly events and analytics.
 */
export function identifyAnonymousLdUserWithEmail(
  props: IdentifyAnonymousLdUserWithEmailParams
): void {
  const { ldClient, email } = props;
  const context = {
    ...getAnonymousLdUser(),
    email,
    _meta: { privateAttributes: ["email"] },
  };

  void (async () => {
    try {
      await ldClient.identify(context);
    } catch {
      // Identification is best-effort; login must continue if LaunchDarkly fails.
    }
  })();
}

interface AnonymousLdIdentifyClient {
  identify(context: CbhUserContext): Promise<unknown>;
}

interface IdentifyAnonymousLdUserWithEmailParams {
  ldClient: AnonymousLdIdentifyClient;
  email: string;
}
